import React from "react";

import { Delete, PictureAsPdf } from "@mui/icons-material";
import {
  Box,
  Card,
  IconButton,
  LinearProgress,
  Typography,
} from "@mui/material";

const PDF = ({ files, setFiles }) => {
  const uploadingFiles = files?.filter((f) => f?.status === "In-progress");

  const handleDeleteAll = () => {
    setFiles([]);
  };

  return (
    <Box mb={2}>
      {/* <Typography color="#606060" fontWeight={600}>{uploadingFiles?.length ? 'Uploading Files' : 'Uploaded Files'}</Typography> */}

      {files?.length > 0 && (
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mb={1}
          mr={2}
          sx={{
            cursor: "pointer",
          }}
          onClick={handleDeleteAll}
        >
          <Delete
            sx={{
              width: "16px",
              height: "16px",
              color: "#9048FB",
              mr: 0.5,
            }}
          />
          <Typography
            color="#9048FB"
            fontFamily="Outfit"
            fontWeight={500}
            fontSize="14px"
          >
            Delete All
          </Typography>
        </Box>
      )}

      {files?.map((file, i) => {
        return (
          <Card
            key={i}
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              bgcolor: "#F9F7FB",
              boxShadow: 0,
              p: 2,
              borderRadius: "11px",
            }}
          >
            <Box
              width="32px"
              height="32px"
              bgcolor="white"
              className="center"
              borderRadius="8px"
            >
              <PictureAsPdf sx={{ color: "#4BC7E1", width: 18, height: 18 }} />
            </Box>
            <Box flex={1}>
              <Typography
                fontWeight={600}
                color="#384B52"
                fontSize="14px"
                mb={0.3}
              >
                {file.file.name}
              </Typography>
              {file.status === "In-progress" ? (
                <LinearProgress color="purple" sx={{ width: "100%" }} />
              ) : (
                <Typography fontSize="12px" color="success.main">
                  Uploaded
                </Typography>
              )}
            </Box>
            {file.status !== "In-progress" && (
              <IconButton
                size="small"
                onClick={() =>
                  setFiles(files?.filter((f, index) => i !== index))
                }
              >
                <Delete sx={{ width: "20px", height: "20px" }} />
              </IconButton>
            )}
          </Card>
        );
      })}
    </Box>
  );
};

export default PDF;
